module.exports = ".big-post img {\n  width: 100% !important;\n  height: auto !important;\n  border-radius: 4px; }\n\n.big-post p {\n  margin-top: 0px;\n  text-align: justify; }\n\nh3 {\n  text-align: justify !important;\n  font-size: 21px !important;\n  line-height: 22px !important;\n  border-bottom: 1px solid #ccc;\n  padding: 0px 0px 15px 0px;\n  margin-bottom: 10px; }\n\n.post-container {\n  margin-top: 7px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/news/wordpress-big-post/wordpress-big-post.component.scss
// module id = ./src/app/fiscalia/component/news/wordpress-big-post/wordpress-big-post.component.scss
// module chunks = main